import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: null,
};

const duelsActiveMatchSlice = createSlice({
  name: "duelsActiveMatch",
  initialState,
  reducers: {
    setDuelsActiveMatch: (state, action) => {
      state.data = action.payload;
    },
    clearDuelsActiveMatch: (state) => {
      state.data = null;
    },
  },
});

export const { setDuelsActiveMatch, clearDuelsActiveMatch } =
  duelsActiveMatchSlice.actions;

export const selectDuelsActiveMatch = (state) => state.duelsActiveMatch.data;

export default duelsActiveMatchSlice.reducer;
